import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import orderBy from 'lodash/orderBy';
import { compose, withProps } from 'recompose';
import { Map } from 'immutable';

import pure from '../../lib/pure';
import { remove } from './actions';
import * as selectors from './selectors';
import * as styles from './styles.css';
import Notification from './Notification';
import { NotificationTypes } from './constants';

const getNotification = (notifications, id) => notifications.find(
  notification => notification.id === id,
);

class Notifications extends Component {
  static propTypes = {
    notifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
      }),
    ).isRequired,
    remove: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.delayedRemoval = (id, time) => setTimeout(() => this.props.remove({ id }), time);
    props.notifications.forEach(notification => this.delayedRemoval(notification.id));
  }

  componentDidUpdate(prevProps) {
    const previousErrorIds = prevProps.notifications.map(notification => notification.id);
    const nextErrorIds = this.props.notifications.map(notification => notification.id);
    const diffIds = nextErrorIds.filter(id => !previousErrorIds.includes(id));
    diffIds.map(id => this.delayedRemoval(
      id,
      getNotification(this.props.notifications, id).type === NotificationTypes.SUCCESS
        ? 3200 : 6400,
    ));
  }

  render() {
    const { notifications } = this.props;
    if (notifications.length === 0) {
      return null;
    }

    return (
      <div
        className={`clearfix ${styles.container}`}
      >
        {notifications.map(notification => (
          <CSSTransitionGroup
            key={notification.id}
            transitionName={styles}
            transitionEnterTimeout={300}
            transitionLeaveTimeout={700}
            transitionAppearTimeout={500}
            transitionAppear
          >
            <Notification
              type={notification.type}
              message={notification.message}
            />
          </CSSTransitionGroup>
        ))
        }
        <br />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    notifications: selectors.notifications(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    remove,
  }, dispatch);
}

export default compose(
  pure,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ notifications }) => ({
    notifications: Map.isMap(notifications) ? orderBy(notifications.toArray(), ['id'], ['desc']) : notifications,
  })),
)(Notifications);
